export default __webpack_public_path__ + "static/media/130EF637-EB5C-48DE-B15F-A1F262FEB623_1_105_c.55589d80.jpeg";